//CreateDictaSet

import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye, faClock, faDollarSign, faEarth, faExclamationTriangle, faHeartPulse, faLightbulb, faListCheck, faLock, faMicrochip, faMicrophone, faRobot, faTree, faUserSecret } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import validateManyFields from '../../validations';
import '../../styles/Concerns.css';
import '../../styles/Alert.css';
import Tooltip from '../../components/utils/Tooltip';


const CreateDictaSet = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const { bookId } = useParams();
  const mode = bookId === undefined ? "add" : "update";
  const [bookMaster, setBookMaster] = useState(null);
  const [showDetailForm, setShowDetailForm] = useState(false);
  const [countFormErrors, setCountFormErrors] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [error, setError] = useState(null);
  const [startTime, setStartTime] = useState(false);
  const [endTime, setEndTime] = useState(false);
  const [duration, setDuration] = useState('');
  const [additionalDataEntry, setAdditionalDataEntry] = useState(false);
  const [isFlagged, setIsFlagged] = useState(false);
  const [isUpdateLock, setIsUpdateLock] = useState(false);

  const [formData, setFormData] = useState({
    subject: '',
    language: '',
    genre: '',
    bookCode: '',
    bookTitle: '',
    bookDesc: '',
    bookEdition: '',
    bookPages: 0,
    bookAPI: '',
    bookImage: '',
    coverImagePath: '',
    bookAuthor: '',
    authorBio: '',
    publisherName: '',
    sponsorName: '',
    coverPrice: 0,
    offerPrice: 0,
    hasDiscountedPrice: 0,
    discountedPrice: 0,
    discountPercent: 0,
    discountAmount: 0,
    currency: '',
    isFlipBook: false,
    isAudioBook: false,
    isVideoBook: 0,
    isPictureBook: 0,
    isTextBook: 0,
    isTouchBook: 0,
    remarks: '',
    tags: '',
    dateCreated: new Date(),
    dateModified: new Date(),
    isActive: 1,
    isDeleted: 0,
    isCollection: false,
    bookCollectionName: '',
    bookHighlight: '',
    displayIndex: 10,
    hasPracticeTest: 0,
    hasAssignment: 0,
    hasExam: 0,
    hasCertificate: 0,
    maxFreePageRead: 0,
    maxPaidPageRead: 0,
    pageHasAd: 0,
    pageAdId: '',
    isAuthorOffer: false,
    authorOffer: '',
    isPublisherOffer: false,
    publisherOffer: '',
    isSellerOffer: false,
    sellerOffer: '',
    isPlatformOffer: false,
    platformOffer: '',
    isOtherOnline: false,
    otherOnline: [],
    isPrinted: false,
    isBookStores: false,
    bookStores: [],
    isSecondHand: false,
    secondHand: [],
    hasPaperback: false,
    tabGroup: '',
    createdBy: authState.user._id,
    isBestSeller: 0,
    isFree: 0,
    freeReads: 25,
    paidReads: 500,
    t5wLink: '',
    amazonLink: '',
    dukaanLink: '',
    category: '',
    subCategory: '',
    isT5W: 0,
    isAdult: 0,
    isChildren: 0,
    isWomen: 0,
    isCompetitive: 0,
    bookLink: [],
    isAvailable: 0,
    isPromotional: 0,
    isUpcoming: 0,
    canDownload: 0,
    imageData: '',
    enableReadHistory: 0,
    ttsEngine: 't5y',
    ttsLang: 'en-US',
    ttsVolLevel: 1.0,
    ttsSpeechRate: 1.0,
    ttsPitchLevel: 1.0,
    ttsGender: 'ttsDefault',
    ttsCharacter: 'ttsDefault',
    ttsRemarks: '',
    isPartOfCollection: false,
    bookCollectionId: null,
    videoBookURL: [],
    isDictaBook: false,
    isCourse: false,
    isProgram: false,
    isPublisher: false,
    publisherCode: null,
    isInstitutional: false,
    institutionCode: null,
    isTVBook: false,
    isARBook: false,
    isMLM: false,
    MLMCommissionStructure: '',
    isBookClubEnabled: false,
    isCorpPassEnabled: false,
    isFlashReferralEnabled: true,
    isPriceInDollarEnabled: false,
    inrToDollarConversionRate: 80.00,
    dollarPriceMultiplyFactor: 1.00
  });
  
  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);

  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/books/getforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: {bookId: bookId}
      };
      // console.log("Getting Data for Update here",config);
      // console.log("Existing formData",formData);

      fetchData(config, { showSuccessToast: false })
      .then((data) => {
        // console.log('Response for update:', data.bookmaster);
        // setBookMaster(data.bookMaster)
        setFormData({
          subject: data.bookmaster.subject,
            language: data.bookmaster.language,
            genre: data.bookmaster.genre,
            bookCode: data.bookmaster.bookCode,
            bookTitle: data.bookmaster.bookTitle,
            bookDesc: data.bookmaster.bookDesc,
            bookEdition: data.bookmaster.bookEdition,
            bookPages: data.bookmaster.bookPages,
            bookAPI: data.bookmaster.bookAPI,
            bookImage: data.bookmaster.bookImage,
            coverImagePath: data.bookmaster.coverImagePath,
            bookAuthor: data.bookmaster.bookAuthor,
            authorBio: data.bookmaster.authorBio,
            publisherName: data.bookmaster.publisherName,
            sponsorName: data.bookmaster.sponsorName,
            coverPrice: data.bookmaster.coverPrice,
            offerPrice: data.bookmaster.offerPrice,
            hasDiscountedPrice: data.bookmaster.hasDiscountedPrice,
            discountedPrice: data.bookmaster.discountedPrice,
            discountPercent: data.bookmaster.discountPercent,
            discountAmount: data.bookmaster.discountAmount,
            currency: data.bookmaster.currency,
            isFlipBook: data.bookmaster.isFlipBook,
            isAudioBook: data.bookmaster.isAudioBook,
            isVideoBook: data.bookmaster.isVideoBook,
            isPictureBook: data.bookmaster.isPictureBook,
            isTextBook: data.bookmaster.isTextBook,
            isTouchBook: data.bookmaster.isTouchBook,
            remarks: data.bookmaster.remarks,
            tags: data.bookmaster.tags,
            dateCreated: new Date(data.bookmaster.dateCreated),
            dateModified: new Date(data.bookmaster.dateModified),
            isActive: data.bookmaster.isActive,
            isDeleted: data.bookmaster.isDeleted,
            isCollection: data.bookmaster.isCollection,
            bookCollectionName: data.bookmaster.bookCollectionName,
            bookHighlight: data.bookmaster.bookHighlight,
            displayIndex: data.bookmaster.displayIndex,
            hasPracticeTest: data.bookmaster.hasPracticeTest,
            hasAssignment: data.bookmaster.hasAssignment,
            hasExam: data.bookmaster.hasExam,
            hasCertificate: data.bookmaster.hasCertificate,
            maxFreePageRead: data.bookmaster.maxFreePageRead,
            maxPaidPageRead: data.bookmaster.maxPaidPageRead,
            pageHasAd: data.bookmaster.pageHasAd,
            pageAdId: data.bookmaster.pageAdId,
            isAuthorOffer: data.bookmaster.isAuthorOffer,
            authorOffer: data.bookmaster.authorOffer,
            isPublisherOffer: data.bookmaster.isPublisherOffer,
            publisherOffer: data.bookmaster.publisherOffer,
            isSellerOffer: data.bookmaster.isSellerOffer,
            sellerOffer: data.bookmaster.sellerOffer,
            isPlatformOffer: data.bookmaster.isPlatformOffer,
            platformOffer: data.bookmaster.platformOffer,
            isOtherOnline: data.bookmaster.isOtherOnline,
            otherOnline: data.bookmaster.otherOnline,
            isPrinted: data.bookmaster.isPrinted,
            isBookStores: data.bookmaster.isBookStores,
            bookStores: data.bookmaster.bookStores,
            isSecondHand: data.bookmaster.isSecondHand,
            secondHand: data.bookmaster.secondHand,
            hasPaperback: data.bookmaster.hasPaperback,
            tabGroup: data.bookmaster.tabGroup,
            createdBy: data.bookmaster.createdBy,
            isBestSeller: data.bookmaster.isBestSeller,
            isFree: data.bookmaster.isFree,
            freeReads: data.bookmaster.freeReads,
            paidReads: data.bookmaster.paidReads,
            t5wLink: data.bookmaster.t5wLink,
            amazonLink: data.bookmaster.amazonLink,
            dukaanLink: data.bookmaster.dukaanLink,
            category: data.bookmaster.category,
            subCategory: data.bookmaster.subCategory,
            isT5W: data.bookmaster.isT5W,
            isAdult: data.bookmaster.isAdult,
            isChildren: data.bookmaster.isChildren,
            isWomen: data.bookmaster.isWomen,
            isCompetitive: data.bookmaster.isCompetitive,
            bookLink: data.bookmaster.bookLink,
            isAvailable: data.bookmaster.isAvailable,
            isPromotional: data.bookmaster.isPromotional,
            isUpcoming: data.bookmaster.isUpcoming,
            canDownload: data.bookmaster.canDownload,
            imageData: data.bookmaster.imageData,
            enableReadHistory: data.bookmaster.enableReadHistory,
            ttsEngine: data.bookmaster.ttsEngine,
            ttsLang: data.bookmaster.ttsLang,
            ttsVolLevel: data.bookmaster.ttsVolLevel,
            ttsSpeechRate: data.bookmaster.ttsSpeechRate,
            ttsPitchLevel: data.bookmaster.ttsPitchLevel,
            ttsGender: data.bookmaster.ttsGender,
            ttsCharacter: data.bookmaster.ttsCharacter,
            ttsRemarks: data.bookmaster.ttsRemarks,
            isPartOfCollection: data.bookmaster.isPartOfCollection,
            bookCollectionId: data.bookmaster.bookCollectionId,
            videoBookURL: data.bookmaster.videoBookURL,
            isDictaBook: data.bookmaster.isDictaBook,
            isCourse: data.bookmaster.isCourse,
            isProgram: data.bookmaster.isProgram,
            isPublisher: data.bookmaster.isPublisher,
            publisherCode: data.bookmaster.publisherCode,
            isInstitutional: data.bookmaster.isInstitutional,
            institutionCode: data.bookmaster.institutionCode,
            isTVBook: data.bookmaster.isTVBook,
            isARBook: data.bookmaster.isARBook,
            isMLM: data.bookmaster.isMLM,
            MLMCommissionStructure: data.bookmaster.MLMCommissionStructure,
            isBookClubEnabled: data.bookmaster.isBookClubEnabled,
            isCorpPassEnabled: data.bookmaster.isCorpPassEnabled,
            isFlashReferralEnabled: data.bookmaster.isFlashReferralEnabled,
            isPriceInDollarEnabled: data.bookmaster.isPriceInDollarEnabled,
            inrToDollarConversionRate: data.bookmaster.inrToDollarConversionRate,
            dollarPriceMultiplyFactor: data.bookmaster.dollarPriceMultiplyFactor
        });
      })
      .catch((error) => {
        console.error("Error fetching Book Master data:", error);
        setError("Error fetching Book Master data");
      });
    }
  }, [mode, authState, fetchData, setBookMaster]);

  const handleChange = (e) => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  };

  const handleStartDateChange = (date) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      startTime: isoDate,
    }));
  };


  const handleReset = e => {
    e.preventDefault();
    setFormData({
      subject: bookMaster.subject,
      language: bookMaster.language,
      genre: bookMaster.genre,
      bookCode: bookMaster.bookCode,
      bookTitle: bookMaster.bookTitle,
      bookDesc: bookMaster.bookDesc,
      bookEdition: bookMaster.bookEdition,
      bookPages: bookMaster.bookPages,
      bookAPI: bookMaster.bookAPI,
      bookImage: bookMaster.bookImage,
      coverImagePath: bookMaster.coverImagePath,
      bookAuthor: bookMaster.bookAuthor,
      authorBio: bookMaster.authorBio,
      publisherName: bookMaster.publisherName,
      sponsorName: bookMaster.sponsorName,
      coverPrice: bookMaster.coverPrice,
      offerPrice: bookMaster.offerPrice,
      hasDiscountedPrice: bookMaster.hasDiscountedPrice,
      discountedPrice: bookMaster.discountedPrice,
      discountPercent: bookMaster.discountPercent,
      discountAmount: bookMaster.discountAmount,
      currency: bookMaster.currency,
      isFlipBook: bookMaster.isFlipBook,
      isAudioBook: bookMaster.isAudioBook,
      isVideoBook: bookMaster.isVideoBook,
      isPictureBook: bookMaster.isPictureBook,
      isTextBook: bookMaster.isTextBook,
      isTouchBook: bookMaster.isTouchBook,
      remarks: bookMaster.remarks,
      tags: bookMaster.tags,
      dateCreated: new Date(bookMaster.dateCreated),
      dateModified: new Date(bookMaster.dateModified),
      isActive: bookMaster.isActive,
      isDeleted: bookMaster.isDeleted,
      isCollection: bookMaster.isCollection,
      bookCollectionName: bookMaster.bookCollectionName,
      bookHighlight: bookMaster.bookHighlight,
      displayIndex: bookMaster.displayIndex,
      hasPracticeTest: bookMaster.hasPracticeTest,
      hasAssignment: bookMaster.hasAssignment,
      hasExam: bookMaster.hasExam,
      hasCertificate: bookMaster.hasCertificate,
      maxFreePageRead: bookMaster.maxFreePageRead,
      maxPaidPageRead: bookMaster.maxPaidPageRead,
      pageHasAd: bookMaster.pageHasAd,
      pageAdId: bookMaster.pageAdId,
      isAuthorOffer: bookMaster.isAuthorOffer,
      authorOffer: bookMaster.authorOffer,
      isPublisherOffer: bookMaster.isPublisherOffer,
      publisherOffer: bookMaster.publisherOffer,
      isSellerOffer: bookMaster.isSellerOffer,
      sellerOffer: bookMaster.sellerOffer,
      isPlatformOffer: bookMaster.isPlatformOffer,
      platformOffer: bookMaster.platformOffer,
      isOtherOnline: bookMaster.isOtherOnline,
      otherOnline: bookMaster.otherOnline,
      isPrinted: bookMaster.isPrinted,
      isBookStores: bookMaster.isBookStores,
      bookStores: bookMaster.bookStores,
      isSecondHand: bookMaster.isSecondHand,
      secondHand: bookMaster.secondHand,
      hasPaperback: bookMaster.hasPaperback,
      tabGroup: bookMaster.tabGroup,
      createdBy: bookMaster.createdBy,
      isBestSeller: bookMaster.isBestSeller,
      isFree: bookMaster.isFree,
      freeReads: bookMaster.freeReads,
      paidReads: bookMaster.paidReads,
      t5wLink: bookMaster.t5wLink,
      amazonLink: bookMaster.amazonLink,
      dukaanLink: bookMaster.dukaanLink,
      category: bookMaster.category,
      subCategory: bookMaster.subCategory,
      isT5W: bookMaster.isT5W,
      isAdult: bookMaster.isAdult,
      isChildren: bookMaster.isChildren,
      isWomen: bookMaster.isWomen,
      isCompetitive: bookMaster.isCompetitive,
      bookLink: bookMaster.bookLink,
      isAvailable: bookMaster.isAvailable,
      isPromotional: bookMaster.isPromotional,
      isUpcoming: bookMaster.isUpcoming,
      canDownload: bookMaster.canDownload,
      imageData: bookMaster.imageData,
      enableReadHistory: bookMaster.enableReadHistory,
      ttsEngine: bookMaster.ttsEngine,
      ttsLang: bookMaster.ttsLang,
      ttsVolLevel: bookMaster.ttsVolLevel,
      ttsSpeechRate: bookMaster.ttsSpeechRate,
      ttsPitchLevel: bookMaster.ttsPitchLevel,
      ttsGender: bookMaster.ttsGender,
      ttsCharacter: bookMaster.ttsCharacter,
      ttsRemarks: bookMaster.ttsRemarks,
      isPartOfCollection: bookMaster.isPartOfCollection,
      bookCollectionId: bookMaster.bookCollectionId,
      videoBookURL: bookMaster.videoBookURL,
      isDictaBook: bookMaster.isDictaBook,
      isCourse: bookMaster.isCourse,
      isProgram: bookMaster.isProgram,
      isPublisher: bookMaster.isPublisher,
      publisherCode: bookMaster.publisherCode,
      isInstitutional: bookMaster.isInstitutional,
      institutionCode: bookMaster.institutionCode,
      isTVBook: bookMaster.isTVBook,
      isARBook: bookMaster.isARBook,
      isMLM: bookMaster.isMLM,
      MLMCommissionStructure: bookMaster.MLMCommissionStructure,
      isBookClubEnabled: bookMaster.isBookClubEnabled,
      isCorpPassEnabled: bookMaster.isCorpPassEnabled,
      isFlashReferralEnabled: bookMaster.isFlashReferralEnabled,
      isPriceInDollarEnabled: bookMaster.isPriceInDollarEnabled,
      inrToDollarConversionRate: bookMaster.inrToDollarConversionRate,
      dollarPriceMultiplyFactor: bookMaster.dollarPriceMultiplyFactor
    });
  }

  const handleSubmit = e => {
    e.preventDefault();
    const error = validateForm(formData);
    // console.log("error : ",error," no. of error",Object.keys(error).length);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ",setFormErrors);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = { 
        url: "/bookMasters", 
        method: "post",
        data: {formData: formData, user: authState.user._id, startTime: startTime}, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data ",JSON.stringify(formData, null, 2), " User ",authState.user._id);


      fetchData(config).then(() => {
        navigate("/authordesk-bookmasters");
      });
    }
    else {
      const config = { 
        url: `/books/${bookId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data for "+mode+" Book Master",config);

      fetchData(config).then(() => {
        navigate("/authordesk-bookmasters");
      })
      .catch((error) => {
        console.error("Error updating Book Master:", error);
        setError("Error updating Book Master");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.subject) {
      errors.subject = "Subject is required";
    } else if (formData.subject.length > 50) {
      errors.subject = "Subject cannot exceed 50 characters";
    }
    if (!formData.language) {
      errors.language = "Language is required";
    } else if (formData.language.length > 50) {
      errors.language = "Language cannot exceed 50 characters";
    }    
    if (!formData.bookTitle) {
      errors.bookTitle = "Title is required";
    } else if (formData.bookTitle.length > 200) {
      errors.bookTitle = "Title cannot exceed 200 characters";
    }
    if (!formData.bookDesc) {
      errors.bookDesc = "Description is required";
    } else if (formData.bookDesc.length > 2500) {
      errors.bookDesc = "Description cannot exceed 2500 characters";
    }
    if (!formData.bookCode) {
      errors.bookCode = "Book Code is required";
    } else if (formData.bookCode.length > 50) {
      errors.bookCode = "Book Code cannot exceed 100 characters";
    }  
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

   const handleDetailFormClick = () => {
    setShowDetailForm(true);
  };

  const handleAddlCheckboxChange = (e) => {
    setAdditionalDataEntry(e.target.checked);
  };


  return (
    <>
      <MainLayout>
        <div>
          <h3 className='text-lg mx-2 border-b border-b-gray-300 text-white'>Authordesk - Book Master Creation</h3>
        </div>
        <div className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full'>
            {loading ? (
              <Loader />
            ) : (
            <div className='text-sm'>
              <div className='flex justify-center'>
                <h2 className="ml-2 text-xl text-yellow-200">{mode === "add" ? "Add New Book Master" : "Edit Book Master"}</h2>
              </div>
              <div className="border-container text-m">
                  <div>
                    <label>
                      <input className='mr-4' type="checkbox" checked={showDetailForm} onChange={(e) => setShowDetailForm(!showDetailForm)} />
                      Detail Entry 
                      <FontAwesomeIcon icon={faListCheck} className='text-yellow-200 text-lg ml-2 mr-2'/>
                    </label>
                  </div>
              </div>
              <div className="border-container-gray ml-8">
                <div className="mb-2 text-sm">
                  <label htmlFor="subject">Subject:</label>
                  <br />
                  <input 
                    type="text" 
                    name="subject" 
                    id="subject" 
                    value={formData.subject}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '150px' }} 
                  />
                  {fieldError("subject")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="language">Language:</label>
                  <br />
                  <input 
                    type="text" 
                    name="language" 
                    id="language" 
                    value={formData.language}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("language")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="bookCode">Book Code:</label>
                  <br />
                  <input 
                    type="text" 
                    name="bookCode" 
                    id="bookCode" 
                    value={formData.bookCode}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '200px' }} 
                  />
                  {fieldError("bookCode")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="bookTitle">Book Title:</label>
                  <br />
                  <input 
                    type="text" 
                    name="bookTitle" 
                    id="bookTitle" 
                    value={formData.bookTitle}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("bookTitle")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="bookDesc">Book Description:</label>
                  <br />
                  <textarea 
                    name="bookDesc" 
                    id="bookDesc" 
                    value={formData.bookDesc}
                    onChange={handleChange}
                    maxLength="2000"
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%', height: '250px' }} 
                  />
                  {fieldError("bookDesc")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="genre">Genre:</label>
                  <br />
                  <input 
                    type="text" 
                    name="genre" 
                    id="genre" 
                    value={formData.genre}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("genre")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="bookEdition">Book Edition:</label>
                  <br />
                  <input 
                    type="text" 
                    name="bookEdition" 
                    id="bookEdition" 
                    value={formData.bookEdition}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("bookEdition")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="bookPages">Book Pages:</label>
                  <br />
                  <input 
                    type="number" 
                    name="bookPages" 
                    id="bookPages" 
                    value={formData.bookPages}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("bookPages")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="bookAPI">Book API:</label>
                  <br />
                  <input 
                    type="text" 
                    name="bookAPI" 
                    id="bookAPI" 
                    value={formData.bookAPI}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("bookAPI")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="bookImage">Book Image URL:</label>
                  <br />
                  <input 
                    type="text" 
                    name="bookImage" 
                    id="bookImage" 
                    value={formData.bookImage}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '150px' }} 
                  />
                  {fieldError("bookImage")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="coverImagePath">Cover Image Path:</label>
                  <br />
                  <input 
                    type="text" 
                    name="coverImagePath" 
                    id="coverImagePath" 
                    value={formData.coverImagePath}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '200px' }} 
                  />
                  {fieldError("coverImagePath")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="bookAuthor">Book Author:</label>
                  <br />
                  <input 
                    type="text" 
                    name="bookAuthor" 
                    id="bookAuthor" 
                    value={formData.bookAuthor}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '250px' }} 
                  />
                  {fieldError("bookAuthor")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="authorBio">Author Bio:</label>
                  <br />
                  <textarea 
                    name="authorBio" 
                    id="authorBio" 
                    value={formData.authorBio}
                    onChange={handleChange}
                    maxLength="1000"
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%', height: '100px' }} 
                  />
                  {fieldError("authorBio")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="publisherName">Publisher Name:</label>
                  <br />
                  <input 
                    type="text" 
                    name="publisherName" 
                    id="publisherName" 
                    value={formData.publisherName}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("publisherName")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="sponsorName">Sponsor Name:</label>
                  <br />
                  <input 
                    type="text" 
                    name="sponsorName" 
                    id="sponsorName" 
                    value={formData.sponsorName}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("sponsorName")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="coverPrice">Cover Price:</label>
                  <br />
                  <input 
                    type="number" 
                    name="coverPrice" 
                    id="coverPrice" 
                    value={formData.coverPrice}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("coverPrice")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="offerPrice">Offer Price:</label>
                  <br />
                  <input 
                    type="number" 
                    name="offerPrice" 
                    id="offerPrice" 
                    value={formData.offerPrice}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("offerPrice")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="hasDiscountedPrice">
                  <br />
                  <input 
                    type="checkbox" 
                    name="hasDiscountedPrice" 
                    id="hasDiscountedPrice" 
                    checked={formData.hasDiscountedPrice}
                    onChange={(e) => setFormData({ ...formData, hasDiscountedPrice: e.target.checked })}
                    className='mr-4'
                  />
                    Has Discounted Price
                  </label>
                  {fieldError("hasDiscountedPrice")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="discountedPrice">Discounted Price:</label>
                  <br />
                  <input 
                    type="number" 
                    name="discountedPrice" 
                    id="discountedPrice" 
                    value={formData.discountedPrice}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("discountedPrice")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="discountPercent">Discount Percent:</label>
                  <br />
                  <input 
                    type="number" 
                    name="discountPercent" 
                    id="discountPercent" 
                    value={formData.discountPercent}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '50px' }} 
                  />
                  {fieldError("discountPercent")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="discountAmount">Discount Amount:</label>
                  <br />
                  <input 
                    type="number" 
                    name="discountAmount" 
                    id="discountAmount" 
                    value={formData.discountAmount}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("discountAmount")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="currency">Currency:</label>
                  <br />
                  <input 
                    type="text" 
                    name="currency" 
                    id="currency" 
                    value={formData.currency}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '50px' }} 
                  />
                  {fieldError("currency")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isFlipBook">
                  <br />
                  <input 
                    type="checkbox" 
                    name="isFlipBook" 
                    id="isFlipBook" 
                    checked={formData.isFlipBook}
                    onChange={(e) => setFormData({ ...formData, isFlipBook: e.target.checked })}
                    className='mr-4'
                    />
                      Is Flip Book
                    </label>
                  {fieldError("isFlipBook")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isAudioBook">
                  <br />
                  <input 
                    type="checkbox" 
                    name="isAudioBook" 
                    id="isAudioBook" 
                    checked={formData.isAudioBook}
                    onChange={(e) => setFormData({ ...formData, isAudioBook: e.target.checked })}
                    className='mr-4'
                    />
                      Is Audio Book
                    </label>
                  {fieldError("isAudioBook")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isVideoBook">Is Video Book:</label>
                  <br />
                  <input 
                    type="number" 
                    name="isVideoBook" 
                    id="isVideoBook" 
                    value={formData.isVideoBook}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '50px' }} 
                  />
                  {fieldError("isVideoBook")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isPictureBook">Is Picture Book:</label>
                  <br />
                  <input 
                    type="number" 
                    name="isPictureBook" 
                    id="isPictureBook" 
                    value={formData.isPictureBook}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '50px' }} 
                  />
                  {fieldError("isPictureBook")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isTextBook">Is Text Book:</label>
                  <br />
                  <input 
                    type="number" 
                    name="isTextBook" 
                    id="isTextBook" 
                    value={formData.isTextBook}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '50px' }} 
                  />
                  {fieldError("isTextBook")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isTouchBook">Is Touch Book:</label>
                  <br />
                  <input 
                    type="number" 
                    name="isTouchBook" 
                    id="isTouchBook" 
                    value={formData.isTouchBook}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '50px' }} 
                  />
                  {fieldError("isTouchBook")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="remarks">Remarks:</label>
                  <br />
                  <textarea 
                    name="remarks" 
                    id="remarks" 
                    value={formData.remarks}
                    onChange={handleChange}
                    maxLength="2000"
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%', height: '100%' }} 
                  />
                  {fieldError("remarks")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="tags">Tags:</label>
                  <br />
                  <input 
                    type="text" 
                    name="tags" 
                    id="tags" 
                    value={formData.tags}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("tags")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="dateCreated">Date Created:</label>
                  <br />
                  <input 
                    type="date" 
                    name="dateCreated" 
                    id="dateCreated" 
                    value={formData.dateCreated}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '200px' }} 
                  />
                  {fieldError("dateCreated")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="dateModified">Date Modified:</label>
                  <br />
                  <input 
                    type="date" 
                    name="dateModified" 
                    id="dateModified" 
                    value={formData.dateModified}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '200px' }} 
                  />
                  {fieldError("dateModified")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isActive">
                  <br />
                  <input 
                    type="checkbox" 
                    name="isActive" 
                    id="isActive" 
                    checked={formData.isActive === 1}
                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked ? 1 : 0 })}
                    className='mr-4'
                    />
                      Is Active
                  </label>
                  {fieldError("isActive")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isDeleted">
                  <br />
                  <input 
                    type="checkbox" 
                    name="isDeleted" 
                    id="isDeleted" 
                    checked={formData.isDeleted === 1}
                    onChange={(e) => setFormData({ ...formData, isDeleted: e.target.checked ? 1 : 0 })}
                    className='mr-4'
                    />
                      Is Deleted
                  </label>
                  {fieldError("isDeleted")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isCollection">
                  <br />
                  <input 
                    type="checkbox" 
                    name="isCollection" 
                    id="isCollection" 
                    checked={formData.isCollection}
                    onChange={(e) => setFormData({ ...formData, isCollection: e.target.checked })}
                    className='mr-4'
                    />
                      Is Collection
                  </label>
                  {fieldError("isCollection")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="bookCollectionName">Book Collection Name:</label>
                  <br />
                  <input 
                    type="text" 
                    name="bookCollectionName" 
                    id="bookCollectionName" 
                    value={formData.bookCollectionName}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '250px' }} 
                  />
                  {fieldError("bookCollectionName")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="bookHighlight">Book Highlight:</label>
                  <br />
                  <textarea 
                    name="bookHighlight" 
                    id="bookHighlight" 
                    value={formData.bookHighlight}
                    onChange={handleChange}
                    maxLength="500"
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%', height: '250px' }} 
                  />
                  {fieldError("bookHighlight")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="displayIndex">Display Index:</label>
                  <br />
                  <input 
                    type="number" 
                    name="displayIndex" 
                    id="displayIndex" 
                    value={formData.displayIndex}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("displayIndex")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="hasPracticeTest">
                  <br />
                  <input 
                    type="checkbox" 
                    name="hasPracticeTest" 
                    id="hasPracticeTest" 
                    checked={formData.hasPracticeTest === 1}
                    onChange={(e) => setFormData({ ...formData, hasPracticeTest: e.target.checked ? 1 : 0 })}
                    className='mr-4'
                    />
                      Has Practice Test
                  </label>
                  {fieldError("hasPracticeTest")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="hasAssignment">
                  <br />
                  <input 
                    type="checkbox" 
                    name="hasAssignment" 
                    id="hasAssignment" 
                    checked={formData.hasAssignment === 1}
                    onChange={(e) => setFormData({ ...formData, hasAssignment: e.target.checked ? 1 : 0 })}
                    className='mr-4'
                    />
                     Has Assignment
                  </label>
                  {fieldError("hasAssignment")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="hasExam">
                  <br />
                  <input 
                    type="checkbox" 
                    name="hasExam" 
                    id="hasExam" 
                    checked={formData.hasExam === 1}
                    onChange={(e) => setFormData({ ...formData, hasExam: e.target.checked ? 1 : 0 })}
                    className='mr-4'
                    />
                     Has Exam
                  </label>
                  {fieldError("hasExam")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="hasCertificate">
                  <br />
                  <input 
                    type="checkbox" 
                    name="hasCertificate" 
                    id="hasCertificate" 
                    checked={formData.hasCertificate === 1}
                    onChange={(e) => setFormData({ ...formData, hasCertificate: e.target.checked ? 1 : 0 })}
                    className='mr-4'
                    />
                     Has Certificate
                  </label>
                  {fieldError("hasCertificate")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="maxFreePageRead">Max Free Page Read:</label>
                  <br />
                  <input 
                    type="number" 
                    name="maxFreePageRead" 
                    id="maxFreePageRead" 
                    value={formData.maxFreePageRead}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("maxFreePageRead")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="maxPaidPageRead">Max Paid Page Read:</label>
                  <br />
                  <input 
                    type="number" 
                    name="maxPaidPageRead" 
                    id="maxPaidPageRead" 
                    value={formData.maxPaidPageRead}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("maxPaidPageRead")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="pageHasAd">Page Has Ad:</label>
                  <br />
                  <input 
                    type="number" 
                    name="pageHasAd" 
                    id="pageHasAd" 
                    value={formData.pageHasAd}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '50px' }} 
                  />
                  {fieldError("pageHasAd")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="pageAdId">Page Ad Id:</label>
                  <br />
                  <input 
                    type="text" 
                    name="pageAdId" 
                    id="pageAdId" 
                    value={formData.pageAdId}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '150px' }} 
                  />
                  {fieldError("pageAdId")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isAuthorOffer">
                  <br />
                  <input 
                    type="checkbox" 
                    name="isAuthorOffer" 
                    id="isAuthorOffer" 
                    checked={formData.isAuthorOffer}
                    onChange={(e) => setFormData({ ...formData, isAuthorOffer: e.target.checked })}
                    className='mr-4'
                    />
                     Is Author Offer
                  </label>
                  {fieldError("isAuthorOffer")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="authorOffer">Author Offer:</label>
                  <br />
                  <input 
                    type="text" 
                    name="authorOffer" 
                    id="authorOffer" 
                    value={formData.authorOffer}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("authorOffer")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isPublisherOffer">
                  <br />
                  <input 
                    type="checkbox" 
                    name="isPublisherOffer" 
                    id="isPublisherOffer" 
                    checked={formData.isPublisherOffer}
                    onChange={(e) => setFormData({ ...formData, isPublisherOffer: e.target.checked })}
                    className='mr-4'
                    />
                     Is Publisher Offer
                  </label>
                  {fieldError("isPublisherOffer")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="publisherOffer">Publisher Offer:</label>
                  <br />
                  <input 
                    type="text" 
                    name="publisherOffer" 
                    id="publisherOffer" 
                    value={formData.publisherOffer}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("publisherOffer")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isSellerOffer">
                  <br />
                  <input 
                    type="checkbox" 
                    name="isSellerOffer" 
                    id="isSellerOffer" 
                    checked={formData.isSellerOffer}
                    onChange={(e) => setFormData({ ...formData, isSellerOffer: e.target.checked })}
                    className='mr-4'
                    />
                     Is Seller Offer
                  </label>
                  {fieldError("isSellerOffer")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="sellerOffer">Seller Offer:</label>
                  <br />
                  <input 
                    type="text" 
                    name="sellerOffer" 
                    id="sellerOffer" 
                    value={formData.sellerOffer}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("sellerOffer")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isPlatformOffer">
                  <br />
                  <input 
                    type="checkbox" 
                    name="isPlatformOffer" 
                    id="isPlatformOffer" 
                    checked={formData.isPlatformOffer}
                    onChange={(e) => setFormData({ ...formData, isPlatformOffer: e.target.checked })}
                    className='mr-4'
                    />
                     Is Platform Offer
                  </label>
                  {fieldError("isPlatformOffer")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="platformOffer">Platform Offer:</label>
                  <br />
                  <input 
                    type="text" 
                    name="platformOffer" 
                    id="platformOffer" 
                    value={formData.platformOffer}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("platformOffer")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="bookType">Book Type:</label>
                  <br />
                  <select
                    name="bookType"
                    id="bookType"
                    value={formData.bookType}
                    onChange={handleChange}
                    style={{ border: '1px solid #ccc', padding: '8px', width: '200px' }}
                  >
                    <option value="">Select a book type</option>
                    <option value="ebook">Ebook</option>
                    <option value="physical">Physical</option>
                  </select>
                  {fieldError("bookType")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isFree">
                  <br />
                  <input 
                    type="checkbox" 
                    name="isFree" 
                    id="isFree" 
                    checked={formData.isFree}
                    onChange={(e) => setFormData({ ...formData, isFree: e.target.checked })}
                    className='mr-4'
                    />
                     Is Free
                  </label>
                  {fieldError("isFree")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isPaid">
                  <br />
                  <input 
                    type="checkbox" 
                    name="isPaid" 
                    id="isPaid" 
                    checked={formData.isPaid}
                    onChange={(e) => setFormData({ ...formData, isPaid: e.target.checked })}
                    className='mr-4'
                    />
                     Is Paid
                  </label>
                  {fieldError("isPaid")}
                </div>

                {/* <div className="mb-2 text-sm">
                  <label htmlFor="price">Price:</label>
                  <br />
                  <input 
                    type="number" 
                    name="price" 
                    id="price" 
                    value={formData.price}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("price")}
                </div> */}

                <div className="mb-2 text-sm">
                  <label htmlFor="isFeatured">
                  <br />
                  <input 
                    type="checkbox" 
                    name="isFeatured" 
                    id="isFeatured" 
                    checked={formData.isFeatured}
                    onChange={(e) => setFormData({ ...formData, isFeatured: e.target.checked })}
                    className='mr-4'
                    />
                     Is Featured
                  </label>
                  {fieldError("isFeatured")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="author">Author:</label>
                  <br />
                  <input 
                    type="text" 
                    name="author" 
                    id="author" 
                    value={formData.author}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("author")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="publisher">Publisher:</label>
                  <br />
                  <input 
                    type="text" 
                    name="publisher" 
                    id="publisher" 
                    value={formData.publisher}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("publisher")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="publicationDate">Publication Date:</label>
                  <br />
                  <input 
                    type="date" 
                    name="publicationDate" 
                    id="publicationDate" 
                    value={formData.publicationDate}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '150px' }} 
                  />
                  {fieldError("publicationDate")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="edition">Edition:</label>
                  <br />
                  <input 
                    type="text" 
                    name="edition" 
                    id="edition" 
                    value={formData.edition}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("edition")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="isbn">ISBN:</label>
                  <br />
                  <input 
                    type="text" 
                    name="isbn" 
                    id="isbn" 
                    value={formData.isbn}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("isbn")}
                </div>

                {/* <div className="mb-2 text-sm">
                  <label htmlFor="pageCount">Page Count:</label>
                  <br />
                  <input 
                    type="number" 
                    name="pageCount" 
                    id="pageCount" 
                    value={formData.pageCount}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '150px' }} 
                  />
                  {fieldError("pageCount")}
                </div> */}

                <div className="mb-2 text-sm">
                  <label htmlFor="format">Format:</label>
                  <br />
                  <input 
                    type="text" 
                    name="format" 
                    id="format" 
                    value={formData.format}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("format")}
                </div>

                {/* <div className="mb-2 text-sm">
                  <label htmlFor="description">Description:</label>
                  <br />
                  <textarea 
                    name="description" 
                    id="description" 
                    value={formData.description}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%', height: '250px' }} 
                  />
                  {fieldError("description")}
                </div> */}

                <div className="mb-2 text-sm">
                  <label htmlFor="image">Image:</label>
                  <br />
                  <input 
                    type="text" 
                    name="image" 
                    id="image" 
                    value={formData.image}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("image")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="file">File:</label>
                  <br />
                  <input 
                    type="text" 
                    name="file" 
                    id="file" 
                    value={formData.file}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("file")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="metaData">Meta Data:</label>
                  <br />
                  <textarea 
                    name="metaData" 
                    id="metaData" 
                    value={formData.metaData}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%', height: '100px' }} 
                  />
                  {fieldError("metaData")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="attachments">Attachments:</label>
                  <br />
                  <input 
                    type="text" 
                    name="attachments" 
                    id="attachments" 
                    value={formData.attachments}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("attachments")}
                </div>
              </div>
                <div className="border-container flex flex-col justify-center">
                  <div className="flex justify-center">
                    {Object.keys(formErrors).length > 0 && (
                      <div className="form-errors text-red-300 justify-center items-center">
                        {Object.keys(formErrors).map((key) => (
                          <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="flex justify-center">
                    <button 
                      className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' 
                      disabled={isUpdateLock && mode==="update"}
                      onClick={handleSubmit}>
                        {mode === "add" ? "Add New" : "Update"}
                    </button>
                    <button 
                      className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' 
                      onClick={() => navigate("/authordesk-bookmasters")}>
                        Cancel
                    </button>
                    {mode === "update" && <button className='ml-4 bg-blue-500 text-white px-4 py-2 font-medium hover:bg-blue-600' onClick={handleReset}>Reset</button>}
                  </div>
                </div>
            </div>
          )}
        </div>
      </MainLayout>
    </>
  )
}

export default CreateDictaSet;